import React from 'react';
import classnames from 'classnames';

import './Icon.scss';

export interface IconProps {
    /**
     * Prefix font-family
     */
    prefix?: string;
    /**
     * Name icon
     */
    name: string;
    /**
     * Color style icon
     */
    color?:
        | ''
        | 'primary'
        | 'secondary'
        | 'tertiary'
        | 'accent'
        | 'white'
        | 'gray'
        | 'gray-light'
        | 'gray-dark'
        | 'success'
        | 'warning'
        | 'error'
        | 'info';
    /**
     * Icon size
     */
    size?: string | number;
    /**
     * Clickable attr
     */
    clickable?: boolean;
    /**
     * Class name styles
     */
    className?: string;
    /**
     * Style
     */
    style?: any;
    /**
     * Function called on click icon
     */
    onClick?(): any;
    /**
     * Other props
     */
    [otherProps: string]: any;
}

const Icon: React.FC<IconProps> = ({
    prefix = 'icon',
    name,
    size,
    color,
    clickable = false,
    className,
    style = {},
    onClick,
    ...otherProps
}) => {
    const classNames = classnames(['icon', `${prefix}-${name}`, color, { clickable }, className]);
    const styles = { ...(size ? { fontSize: `${size}px` } : {}), ...style };
    return <i className={classNames} style={styles} onClick={onClick} {...otherProps} />;
};

export default Icon;
